import { Api } from 'models/services/api';
import { CreateOriginalDishCategoryQuery } from 'models/services/graphql';

import { OriginalDishCategoryData, OriginalDishCategoryDataToSave } from '../index';

type DataToCreate = {
  menuCategoryId: string;
  input: OriginalDishCategoryDataToSave;
};

const RequestQuery = `
  mutation CreateOriginalDishCategory($menuCategoryId: ID!, $input: OriginalDishCategoryInput!) {
    ${CreateOriginalDishCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    createOriginalDishCategory: OriginalDishCategoryData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalDishCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createOriginalDishCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };